import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneInTalkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_in_talk"}/>
}
